import React from "react";
import { Footer } from "../themes/userq/Footer/Footer";
import { Logo } from "../themes/userq/Logo/Logo";
import "../page_unauthorized.css";
import { Text } from "../themes/userq/Text/Text";
import { Button } from "../themes/userq/Button/Button";
import { Icon } from "../themes/userq/Icon/Icon";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const ExitTest = () => {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>
                    Exit Test 
                </title>
            </Helmet>
            <div className="header researcher-header d-flex align-items-center header-with-logo-only">
                <div className="container">
                    <div className="header-inner-data body-text body-text body-text-2 medium-font d-flex">
                        <div className="header-lhs-side">
                            <div className="logo">
                                <Logo theme={"white"} background={"black"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="session-loged-out-data">
                <div className="session-log-out-inner-data">
                    <div className="d-flex justify-content-center mb-12">
                    <Icon size={'large'} color={'grav-svg-900'} value={'screen-recording-disable'}/>
                    </div>
                  
                    <Text type={"subtitle-2"} fontWeight={'semi-bold-font'} >The test has been stopped.</Text>
                    <Text
                        type={"body-text-2"}
                        fontWeight={"medium-font"}
                        cssClasses={"gray-color mt-20 mb-32"}
                    >
                       This test requires your screen to be recorded. As you have stopped sharing your screen, the test has automatically stopped. Unfortunately, that means you won’t receive any rewards this time.
                    </Text>

                  
                   <Button onClick={()=>{navigate('/dashboard')}}  type={'primary' } size={'large'} iconLeft={
                   <Icon value={'back-arrow'} colorClass={'gray-50-svg'}/>
                   } label={'Back to Dashboard'}  />
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ExitTest;
